<template>
  <base-credit-card :host-field-id="containerName"
                    :title="'מספר תעודת זהות'"
                    :error-message="socialId.error"
                    :focused="focused"
                    :empty="socialId.isEmpty"/>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

import BaseCreditCard from './BaseCreditCard.vue';

export default {
  name: 'SocialId',
  components: {
    BaseCreditCard,
  },
  data() {
    return {
      containerName: 'social-id-container',
      blurredOnce: false,
      focused: false,
      displayErrorMessage: false,
      errorMessage: '',
    };
  },
  async mounted() {
    const socialId = this.fields.create(window.PayMe.fields.SOCIAL_ID, {
      placeholder: ' ',
      styles: {
        base: {
          'font-size': '20px',
          'text-align': 'right',
          color: '#2b323b',
          '::placeholder': {
            color: '#9b9b9b',
          },
        },
      },
    });
    socialId.mount(`#${this.containerName}`);

    socialId.on('keyup', this.setKeyUpResult);
    socialId.on('validity-changed', this.setKeyUpResult);
    socialId.on('blur', this.markAsBlurred);
    socialId.on('focus', this.markAsFocused);
  },
  computed: {
    ...mapState('subscription', ['fields', 'creditCard']),
    ...mapGetters('subscription', ['creditCardFields']),
    socialId() {
      return this.creditCard[this.creditCardFields.socialId];
    },
  },
  methods: {
    ...mapActions('subscription', ['setCreditCardField']),
    setKeyUpResult(event) {
      const { isValid, isEmpty } = event;
      this.setCreditCardField({ field: this.creditCardFields.socialId, isValid, isEmpty });
    },
    markAsBlurred() {
      this.blurredOnce = true;
      this.focused = false;
    },
    markAsFocused() {
      this.focused = true;
    },
  },
};
</script>
